import {
  PAYMENTS_CLAIMS_PAID_LOADING,
  PAYMENTS_CLAIMS_PAID_SUCCESS,
  PAYMENTS_CLAIMS_PAID_FAILURE,
  CLAIMS_YIELD_ALL_PASSES_METRICS_LOADING,
  CLAIMS_YIELD_ALL_PASSES_METRICS_SUCCESS,
  CLAIMS_YIELD_ALL_PASSES_METRICS_FAILURE,
  SERVICE_TYPE_PASS_WISE_METRICS_LOADING,
  SERVICE_TYPE_PASS_WISE_METRICS_SUCCESS,
  SERVICE_TYPE_PASS_WISE_METRICS_FAILURE,
  PAYMENTS_CLAIMS_SUMMARY_SUCCESS,
  PAYMENTS_CLAIMS_SUMMARY_FAILURE,
  PAYMENTS_CLAIMS_SUMMARY_LOADING,
  PAYMENTS_CLAIMS_DOP_SUCCESS,
  PAYMENTS_CLAIMS_DOP_FAILURE,
  PAYMENTS_CLAIMS_DOP_LOADING,
  CLAIMS_BIFURCATE_METRICS_SUCCESS,
  CLAIMS_BIFURCATE_METRICS_FAILURE,
  CLAIMS_BIFURCATE_METRICS_LOADING,
  PAYMENTS_POLLING_STARTED,
  PAYMENTS_POLLING_COMPLETED,
  PAYMENTS_POLLING_FAILED,
  PAYMENTS_POLLING_RESET
} from '../../../actions/actionTypes';

interface PaymentsState {
  paymentsClaimPaidData: any;
  paymentsClaimPaidIsLoading: boolean;
  paymentsClaimPaidError: string | null;
  paymentsClaimSummaryData: any;
  paymentsClaimSummaryIsLoading: boolean;
  paymentsClaimSummaryError: string | null;
  paymentsClaimDopData: any;
  paymentsClaimDopIsLoading: boolean;
  paymentsClaimDopError: string | null;
  claimsBifurcateMetricsData: any;
  claimsBifurcateMetricsIsLoading: boolean;
  claimsBifurcateMetricsError: string | null;
  claimsYieldAllPassesMetricsData: any;
  claimsYieldAllPassesMetricsIsLoading: boolean;
  claimsYieldAllPassesMetricsError: string | null;
  serviceTypePassWiseMetricsData: any;
  serviceTypePassWiseMetricsIsLoading: boolean;
  serviceTypePassWiseMetricsError: string | null;
  pollingCount: number;
  pollingError: any;
}

const initialState: PaymentsState = {
  paymentsClaimPaidData: {},
  paymentsClaimPaidIsLoading: false,
  paymentsClaimPaidError: null,
  paymentsClaimSummaryData: {},
  paymentsClaimSummaryIsLoading: false,
  paymentsClaimSummaryError: null,
  paymentsClaimDopData: {},
  paymentsClaimDopIsLoading: false,
  paymentsClaimDopError: null,
  claimsBifurcateMetricsData: {},
  claimsBifurcateMetricsIsLoading: false,
  claimsBifurcateMetricsError: null,
  claimsYieldAllPassesMetricsData: {},
  claimsYieldAllPassesMetricsIsLoading: false,
  claimsYieldAllPassesMetricsError: null,
  serviceTypePassWiseMetricsData: {},
  serviceTypePassWiseMetricsIsLoading: false,
  serviceTypePassWiseMetricsError: null,
  pollingCount: 0,
  pollingError: null,
};

const PaymentsReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): PaymentsState => {
  switch (action.type) {
    case PAYMENTS_CLAIMS_PAID_LOADING:
      return {
        ...state,
        paymentsClaimPaidIsLoading: action.payload,
      };

    case PAYMENTS_CLAIMS_PAID_SUCCESS:
      return {
        ...state,
        paymentsClaimPaidData: action.payload,
      };

    case PAYMENTS_CLAIMS_PAID_FAILURE:
      return {
        ...state,
        paymentsClaimPaidError: action.payload,
      };

    case PAYMENTS_CLAIMS_SUMMARY_LOADING:
      return {
        ...state,
        paymentsClaimSummaryIsLoading: action.payload,
      };
    
    case PAYMENTS_CLAIMS_SUMMARY_SUCCESS:
      return {
        ...state,
        paymentsClaimSummaryData: action.payload,
      };
    
    case PAYMENTS_CLAIMS_SUMMARY_FAILURE:
      return {
        ...state,
        paymentsClaimSummaryError: action.payload,
      };
    case PAYMENTS_CLAIMS_DOP_LOADING:
      return {
        ...state,
        paymentsClaimDopIsLoading: action.payload,
      };
    
    case PAYMENTS_CLAIMS_DOP_SUCCESS:
      return {
        ...state,
        paymentsClaimDopData: action.payload,
      };
    
    case PAYMENTS_CLAIMS_DOP_FAILURE:
      return {
        ...state,
        paymentsClaimDopError: action.payload,
      };
    case CLAIMS_BIFURCATE_METRICS_LOADING:
      return {
        ...state,
        claimsBifurcateMetricsIsLoading: action.payload,
      };
    
    case CLAIMS_BIFURCATE_METRICS_SUCCESS:
      return {
        ...state,
        claimsBifurcateMetricsData: action.payload,
      };
    
    case CLAIMS_BIFURCATE_METRICS_FAILURE:
      return {
        ...state,
        claimsBifurcateMetricsError: action.payload,
      };

    case CLAIMS_YIELD_ALL_PASSES_METRICS_LOADING:
      return {
        ...state,
        claimsYieldAllPassesMetricsIsLoading: action.payload,
      };

    case CLAIMS_YIELD_ALL_PASSES_METRICS_SUCCESS:
      return {
        ...state,
        claimsYieldAllPassesMetricsData: action.payload,
      };    case CLAIMS_YIELD_ALL_PASSES_METRICS_FAILURE:
      return {
        ...state,
        claimsYieldAllPassesMetricsError: action.payload,
      };

    case SERVICE_TYPE_PASS_WISE_METRICS_LOADING:
      return {
        ...state,
        serviceTypePassWiseMetricsIsLoading: action.payload,
      };

    case SERVICE_TYPE_PASS_WISE_METRICS_SUCCESS:
      return {
        ...state,
        serviceTypePassWiseMetricsData: action.payload,
      };

    case SERVICE_TYPE_PASS_WISE_METRICS_FAILURE:
      return {
        ...state,
        serviceTypePassWiseMetricsError: action.payload,
      };

    case PAYMENTS_POLLING_STARTED:
return {
        ...state,
        pollingCount: state.pollingCount + 1,
        pollingError: null,
      };

    case PAYMENTS_POLLING_COMPLETED:
      return {
        ...state,
        pollingCount: Math.max(0, state.pollingCount - 1), // Prevent negative counts
        pollingError: null,
      };

    case PAYMENTS_POLLING_FAILED:
      return {
        ...state,
        pollingCount: Math.max(0, state.pollingCount - 1), // Decrement on error too
        pollingError: action.payload,
      };

    case PAYMENTS_POLLING_RESET:
      return {
        ...state,
        pollingCount: 0,
        pollingError: null,
      };

    default:
      return state;
  }
};

export default PaymentsReducer;